import React from 'react';
import Gallery from '../components/Gallery';

const GalleryPage = () => {
  return (
    <div className="gallery-page">
      <Gallery />
    </div>
  );
};

export default GalleryPage;
